export default {
    asMoney: function(number) {
        if (number === null || typeof (number) === 'undefined')
        {return '';}
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');;
    }
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/format-number.js